import EligibilityHistoryTable from "components/admin/EligibilityHistoryTable";
import React from "react";

const HistoryPage = () => {
  return (
    <div>
      <EligibilityHistoryTable />
    </div>
  );
};

export default HistoryPage;
